import { takeEvery, put, fork } from "redux-saga/effects";
import * as actions from "../actions/MasterDataActions";
import * as api from "../../api/MasterDataApi";
import { setBackdrop, resetBackdrop } from "../actions/BackdropActions";
import { showSuccessSnackbar, showErrorSnackbar } from "../actions/SnackbarActions";
import moment from "moment";

function* downloadExcelTemplate() {
    try {
        const { data } = yield api.downloadExcelTemplate();
        const url = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement("a");
        link.href = url;
        const filename = "MOST_MasterDataTemplate" + moment(new Date()).format("DD_MM_YYYY_HH_mm_ss") + ".xlsx"; //name with date time & extension
        link.setAttribute("download", filename); //or any other extension
        document.body.appendChild(link);
        link.click();
    } catch (error) {
        yield put(showErrorSnackbar(error));
    }
}

function* getExcelJsonData(action) {
    try {
        const { data } = yield api.getExcelJsonData(action.payload.data);
        yield put(actions.setExcelJsonData(data));
        yield put(showSuccessSnackbar(data.message));
    } catch (error) {
        yield put(showErrorSnackbar(error));
    }
}

function* uploadExcelFile(action) {
    try {
        const { data } = yield api.uploadExcelFile(action.payload);
        yield put(actions.uploadExcelFileResponse(data));
        yield put(showSuccessSnackbar(data.message));
    } catch (error) {
        yield put(showErrorSnackbar(error));
    }
}

function* watchAll() {
    yield takeEvery(actions.Types.GET_EXCEL_TEMPLATE, downloadExcelTemplate);
    yield takeEvery(actions.Types.GET_MASTER_DATA_EXCEL_JSON, getExcelJsonData);
    yield takeEvery(actions.Types.UPLOAD_EXCEL_FILE, uploadExcelFile);
}

const MasterDataSaga = [fork(watchAll)];

export default MasterDataSaga;
